module.exports = {
//    url: "http://192.168.1.6:5656"
    url: 'https://api.alaroma.in'
}